import { DomainError } from '../errors/domain-error';

export const COMMUNITY_RULES_HTML_MAX_CHARS = 20000;
export const COMMUNITY_CONSENT_COPY_MAX_CHARS = 4000;
export const COMMUNITY_MIN_AGE_POLICY_MAX_CHARS = 2000;
export const COMMUNITY_MODERATOR_ROLE_NAME_MAX_CHARS = 60;

export function normalizeCommunityRulesHtml(value?: string | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_RULES_HTML_MAX_CHARS);
}

export function normalizeCommunityConsentCopy(value?: string | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_CONSENT_COPY_MAX_CHARS);
}

export function normalizeCommunityMinAgePolicyText(value?: string | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return trimmed.slice(0, COMMUNITY_MIN_AGE_POLICY_MAX_CHARS);
}

export function normalizeCommunityModeratorRoleName(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) throw new DomainError('Moderator role name is required');
  if (trimmed.length > COMMUNITY_MODERATOR_ROLE_NAME_MAX_CHARS) {
    throw new DomainError('Moderator role name is too long');
  }
  return trimmed;
}

export function resolveCommunityGuidelinesText(params: {
  rules?: string | null;
  rulesHtml?: string | null;
}): string | null {
  const html = normalizeCommunityRulesHtml(params.rulesHtml);
  if (html) return html;
  const plain = params.rules?.trim();
  return plain || null;
}

export function communityRequiresGuidelinesReaccept(params: {
  communityRulesVersion: number;
  acceptedVersion: number;
  guidelinesText: string | null;
}): boolean {
  if (!params.guidelinesText?.trim()) return false;
  return params.communityRulesVersion > params.acceptedVersion;
}

export function assertGuidelinesScrollAccepted(scrolledToEnd: boolean): void {
  if (!scrolledToEnd) {
    throw new DomainError('Scroll to the end of the community guidelines before accepting');
  }
}

export function bumpCommunityRulesVersion(current: number, rulesChanged: boolean): number {
  if (!rulesChanged) return current;
  return Math.max(1, current + 1);
}
